import { getCookie } from "utils";

export async function postCheckout({ checkoutData }) {
  const tempUserId = getCookie("temp_user_id");

  const response = await fetch(
    `/api/user/checkout${tempUserId ? `?tempUserId=${tempUserId}` : ""}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        checkoutData,
      }),
    }
  );

  const data = await response.json();

  return data;
}
